export const PROCESS_CATEGORIES = [
	{ key: "NEW", label: "Ny", color: "#A7D8C9" },
	{ key: "CONFIRMED_BY_SUPPLIER", label: "Bekräftad", color: "#FFE0A3" },
	{ key: "NOT_STARTED", label: "Ej startad", color: "#C9E4A7" },
	{ key: "ON_HOLD", label: "Väntar", color: "#FFE0A3" },
	{ key: "STARTED", label: "Påbörjad", color: "#F3C7A7" },
	{ key: "PARTIALLY_COMPLETED", label: "Delvis klar", color: "#E3B6F3" },
	{ key: "READY_FOR_DELIVERY", label: "Klar för leverans", color: "#C9E4A7" },
	{ key: "PACKED", label: "Packad", color: "#E3B6F3" },
	{ key: "SHIPPED", label: "Utlevererad", color: "#E3B6F3" },
	{ key: "DELIVERED", label: "Levererad", color: "#9ED6F0" },
	{ key: "FINAL_APPROVED", label: "Slutgodkänd", color: "#A7D8C9" },
	{ key: "DELAYED", label: "Försenad", color: "#FFB3A7" },
	{ key: "CANCELLED", label: "Avbruten", color: "#FFB3A7" },
	{ key: "VOIDED", label: "Makulerad", color: "#B0BEC5" },
];